module.exports = __webpack_public_path__ + "media/images/flags/4x3/gbr-a9bd2845fd9be96eaf964a5e7c68239f.svg";